module.exports = __webpack_public_path__ + "static/media/Preview_Android_Notification_Image.95ad05c4.png";